import { render, staticRenderFns } from "./CaseList.vue?vue&type=template&id=091a8190&scoped=true"
import script from "./CaseList.vue?vue&type=script&lang=js"
export * from "./CaseList.vue?vue&type=script&lang=js"
import style0 from "./CaseList.vue?vue&type=style&index=0&id=091a8190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091a8190",
  null
  
)

export default component.exports